import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  // Grid de 2 columnas: cada par label/valor es una fila propia,
  // por lo que nunca se desfasan aunque un label envuelva a 2 lineas.
  dataGrid: {
    display: 'grid',
    gridTemplateColumns: 'max-content 1fr',
    columnGap: '24px',
    rowGap: '8px',
    padding: '8px 16px 18px',
  },
  lbl: {
    fontSize: '14px',
    lineHeight: '20.02px',
    color: '#3a3a3c',
  },
  val: {
    fontSize: '14px',
    lineHeight: '20.02px',
    textAlign: 'right',
    wordBreak: 'break-word',
  },
  // En movil (<600px = sm de MUI): label arriba, valor abajo.
  [theme.breakpoints.down('sm')]: {
    dataGrid: {
      gridTemplateColumns: '1fr',
      rowGap: '2px',
    },
    lbl: {
      paddingTop: '7px',
    },
    val: {
      textAlign: 'left',
      fontWeight: 500,
    },
  },
}));
